import { useCallback, useEffect, useState } from 'react'
import { AspenPatientTasksService, CancelablePromise, PaginatedDTO_PatientTaskDTO_, PatientTaskDTO } from '../client'

export const usePatientTask = (taskId: string) => {
    const [task, setTask] = useState<PatientTaskDTO | null>(null)
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)

    const fetchTask = useCallback(async () => {
        setLoading(true)
        setError(null)
        try {
            const response: CancelablePromise<PaginatedDTO_PatientTaskDTO_> = AspenPatientTasksService.indexPatientTasksGet({
                taskId
            })
            const data = await response

            if (data && data.data.length > 0) {
                setTask(data.data[0])
            }
        } catch (err) {
            setError('Failed to fetch patient data')
        } finally {
            setLoading(false)
        }
    }, [taskId])

    useEffect(() => {
        fetchTask()
    }, [fetchTask])

    return { task, loading, error, fetchTask }
}
